/**
 * SYM-6201. What the one-line summary under a slide's headline says.
 *
 * The row used to print the slide's length and its transition side by side for
 * every slide, including the first. But the first slide has nothing to come
 * from: the server resolves slide 0 to no transition at all
 * (`CreatomatePayloadMapper.php:587-589`) and only attaches the animation when
 * the slide is not the first (`:170`). So the row was naming a change the video
 * never makes, while the editor beside it -- correctly -- offered no such
 * setting. Two parts of the same screen said different things.
 *
 * The slide keeps its transition either way. Hiding it is a matter of position,
 * not of value, so a slide moved down the list brings its old choice back with
 * it and a slide moved to the front simply stops mentioning one.
 */

export interface SceneRowMetaInput {
  duration: number;
  transition?: string | null;
}

/**
 * @param position where the slide sits in the video, counting from zero.
 */
export function sceneRowMeta(
  { duration, transition }: SceneRowMetaInput,
  position: number
): string {
  const length = `${duration}s`;
  if (position <= 0) return length;
  if (!transition) return length;

  return `${length} · ${transition}`;
}
